@if (!isAuthPage) {
  <app-header></app-header>
  <app-sidebar></app-sidebar>
  <div class="main-content" [class.sidebar-closed]="!sidebarService.isOpen()">
    <router-outlet />
  </div>
} @else {
  <router-outlet />
}
